<script>

    export let title = 'Johannes Ludwig';

    function scrollToTop(){
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }

</script>

<h1 on:click={scrollToTop} class="text-l">{@html title.replace(' ','</br>')}</h1>

<style>
    h1 {
        cursor: pointer;
    }
</style>